import { LAYOUTS, sanitizeFolderName } from '../../layouts.js';
/** Compute where a record's JSON (or blob) lives under the SKJV root. */
export function pathForRecord(namespace, key, displayName, recordFileName) {
    const layout = LAYOUTS[namespace];
    if (layout.kind === 'nested') {
        const sub = sanitizeFolderName(displayName ?? key);
        return {
            folderSegments: [layout.parentFolder, sub],
            fileName: recordFileName ?? layout.recordFileName ?? 'record.json',
            layout,
        };
    }
    if (layout.kind === 'flat') {
        return {
            folderSegments: [layout.parentFolder],
            fileName: recordFileName ?? `${sanitizeFolderName(namespace)}-${sanitizeFolderName(key)}.json`,
            layout,
        };
    }
    // blob
    return {
        folderSegments: [layout.parentFolder],
        fileName: key,
        layout,
    };
}
/** Pull namespace + key back out from a folder path + filename observed in Drive. */
export function namespaceForFolder(parentFolder) {
    for (const [ns, layout] of Object.entries(LAYOUTS)) {
        if (layout.parentFolder === parentFolder)
            return ns;
    }
    return null;
}
/**
 * Folder-naming hint for a record. Prefers explicit `displayName`, then
 * `value.name` (covers envelopes seeded by migration / non-UI writers), then
 * leaves it undefined so downstream falls back to `key`.
 */
export function effectiveDisplayName(rec) {
    if (rec.displayName && rec.displayName.trim())
        return rec.displayName;
    const v = rec.value;
    if (v && typeof v === 'object' && typeof v['name'] === 'string') {
        const name = v['name'].trim();
        if (name)
            return name;
    }
    return undefined;
}
export function recordPathFromEnvelope(rec) {
    return pathForRecord(rec.namespace, rec.key, effectiveDisplayName(rec), rec.recordFileName);
}
//# sourceMappingURL=drive-paths.js.map